import React from 'react';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import ButtonGroup from '@visa/vds/button-group';
import ButtonText from '@visa/vds/button-text';

const BillingReviewButtonPanel = (props) => {
    const panelActions = props.panelActions;

    if (!panelActions.allowApprove && !panelActions.allowDownload)
        return <></>;

    return (
        <>
            <Row>
                <Col>
                    <ButtonGroup direction="right">
                        {panelActions.allowApprove &&
                            <ButtonText colorScheme="primary" onClick={props.onApproveClick}>Approve</ButtonText>}
                        {panelActions.allowDownload &&
                            <ButtonText colorScheme="primary" onClick={props.onDownloadClick}>Download Billing File</ButtonText>}
                    </ButtonGroup>
                </Col>
            </Row>
        </>
    );
}

export default BillingReviewButtonPanel;
